import './style.scss'
import { useContext, useState } from "react";
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AbsoluteContainer, AppText, Button, CenterPopup, CenterPopupContainer, FlexColumn, FlexRow } from "src/style"
import DecisionIcon from 'src/assets/svg/decision-icon'
import { VscChromeClose } from 'react-icons/vsc';

export const DecisionBox: React.FC<any> = () => {
    const { visibility: {decision}, decisionBox } = useContext(VisibilityContext)
    const [isHover, setIsHover] = useState(false)

    async function handleAction (type: string) {
        if (type === 'yes' && decision.yesMethod) await decision.yesMethod()
        else if (decision.noMethod) await decision.noMethod()
        closeDecisionBox()
    }

    function closeDecisionBox () {
        decisionBox.hide()
    }
    
    return (
        <CenterPopupContainer>
            <CenterPopup data-aos="zoom-in">
                <AbsoluteContainer top="2" right="2.5">
                    <VscChromeClose 
                        fontSize='1.6rem' color={isHover ? '#EB5757' : '#000000'}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                        onClick={closeDecisionBox}
                    />
                </AbsoluteContainer>
                <FlexColumn 
                    justifyContent="center" width="36"
                    className="decisionbox-content-container"
                >
                    <DecisionIcon />
                    <AppText 
                        textSize="1.6" color="#181D27" 
                        fontWeight="700" align='center'
                        topMargin="1"
                    >
                        {decision.question}
                    </AppText>
                    <FlexRow 
                        topMargin="3" gap="1.5"
                        className='decision-btns'
                    >
                        <Button 
                            width='17.2' 
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                            onClick={() => handleAction('cancel')}
                        >
                            {decision.cancelBtnText}
                        </Button>
                        <Button 
                            width='17.2' 
                            hoverBgColor={decision.type === 'positive' ? '#F9F8FF' : '#FFEBEB'}
                            //hoverColor='#ffffff'
                            color={decision.type === 'positive' ? '#5627FF' : '#EB5757'}
                            bgColor={decision.type === 'positive' ? '#F9F8FF' : '#FFEBEB'}
                            hoverBorderColor={decision.type === 'positive' ? '#5627FF' : '#EB5757'}
                            onClick={() => handleAction('yes')}
                        >
                            {decision.yesBtnText}
                        </Button>
                    </FlexRow>
                </FlexColumn>
            </CenterPopup>
        </CenterPopupContainer>
    )
}